import React from 'react';
import Mousetrap from 'mousetrap';
import { call } from 'app/utils/function';
const cancelDefaultEvent = (handler) => (evt, combo) => {
    if (evt.preventDefault) {
        evt.preventDefault();
    }
    else {
        evt.returnValue = false;
    }
    handler(evt, combo);
};
const stopCallback = (event, element, _combo) => {
    // if the element has the class "mousetrap" then no need to stop
    if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
        return false;
    }
    // stop for input, select, and textarea
    return (element.tagName === 'INPUT' ||
        element.tagName === 'SELECT' ||
        element.tagName === 'TEXTAREA' ||
        (element instanceof HTMLElement &&
            element.contentEditable &&
            element.contentEditable === 'true') ||
        element.tagName !== 'BODY');
};
export function useShortcuts(shortcuts, callback) {
    const mousetrap = React.useRef(null);
    React.useEffect(() => {
        const mt = Mousetrap();
        mt.stopCallback = stopCallback;
        shortcuts.forEach(shortcut => {
            if (!shortcut.isEnabled()) {
                return;
            }
            const { keys } = shortcut;
            const shortcutHandler = typeof shortcut.handler === 'function'
                ? cancelDefaultEvent(shortcut.handler)
                : cancelDefaultEvent((event, combo) => call(callback, event, combo, shortcut));
            mt.bind(keys, shortcutHandler);
        });
        mousetrap.current = mt;
        return () => {
            mt.reset();
            mousetrap.current = null;
        };
    }, [shortcuts, callback]);
    return [];
}
